import React from "react";
import styles from "./ScoreBoard.module.css";
import HeaderTopic from "../../partials/HeaderTopic";
import BasicButtons from "../../partials/BasicButtons";
import FooterMenu from "../../partials/FooterMenu";

import LeagueScoreTable from "./LeagueScoreTable/LeagueScoreTable";
import LeagueFairTeamsTable from "./LeagueFairTeamsTable/LeagueFairTeamsTable";
import LeagueGoalsKingTable from "./LeagueGoalsKingTable/LeagueGoalsKingTable";
import LeagueAssistsKingTable from "./LeagueAssistsKingTable/LeagueAssistsKingTable";

function ScoreBoard(props) {
  const { user, league, refreshStates } = props;
  return (
    <div className={styles.scoreBoard}>
      <div className={styles.dataBoard}>
        <HeaderTopic topic={"ליגת " + league.name} />
        <BasicButtons user={user} refreshStates={refreshStates} />
        <FooterMenu setActive="scores" />
        <div className={styles.theTable}>
          <LeagueScoreTable />
          <LeagueFairTeamsTable />
          <LeagueGoalsKingTable />
          <LeagueAssistsKingTable />
        </div>
      </div>
    </div>
  );
}

export default ScoreBoard;
